import React, { useState } from "react";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import Button from "../../../../atoms/Button";
import { 
    UPDATE_ANNUAL_STATEMENT_DOCUMENTS, UPDATE_COMPILANCE_OPINIONS_DOCUMENTS, UPDATE_FINANCIAL_REPORTING, 
    UPDATE_LEGAL_ENTITIE_DOCUMENTS, UPDATE_MAILBOX, UPDATE_NATURAL_PERSON_DOCUMENTS, UPDATE_PROVISIONAL_PAYMENTS_DOCUMENTS 
} from "../../../../../api/apiEmpresas";
import { UPLOAD_FILE } from "../../../../../api/apiFiles";
import { useSession } from "../../../../../context/SessionContext";

const ModalUpdateFile = ({ empresa, tipo, documentos, tabla, onClose, refetch, documento }) => {
    const { user } = useSession();
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);

    const updateFunctions = {
        archivo_permanente: {
            LegalEntitie: UPDATE_LEGAL_ENTITIE_DOCUMENTS,
            NaturalPerson: UPDATE_NATURAL_PERSON_DOCUMENTS
        },
        opiniones_cumplimiento: UPDATE_COMPILANCE_OPINIONS_DOCUMENTS,
        declaracion_anual: UPDATE_ANNUAL_STATEMENT_DOCUMENTS,
        pagos_provicionales: UPDATE_PROVISIONAL_PAYMENTS_DOCUMENTS,
        reportes_financieros: UPDATE_FINANCIAL_REPORTING,
        buzones: UPDATE_MAILBOX,
    };

    const updateDocument = async (tabla, empresa, id, data) => {
        if (tabla === "archivo_permanente") {
            const updater = updateFunctions[tabla][empresa.type];
            if (updater) return await updater(id, data);
        } else {
            const updater = updateFunctions[tabla];
            if (updater) return await updater(id, data);
        }
    };

    const updateFileInDocument = (documentos, tipo, documento, s3Key, filename, user) => {
        const previusDocs = documentos[tipo] || [];
    
        const targetDoc = previusDocs.find(doc => doc.key === documento.primaryKey);
        if (!targetDoc) return documentos;
    
        const targetFile = targetDoc.archivos.find(
            fileItem => fileItem.uniqueFile === documento.uniqueFile && fileItem.activo === true
        );
    
        if (targetFile) {
            targetFile.s3Key = s3Key;
            targetFile.filename = filename;
            targetFile.user = user?.roleInfo?.name;
        }
    
        return { ...documentos, [tipo]: previusDocs };
    };

    const onUploadSubmit = async () => {
        try {
            setLoading(true);
            const { name: filename, type: mimetype } = file;
            const { url, s3Key } = await UPLOAD_FILE(empresa.id, filename, mimetype, `${tabla}/${tipo}/`);

            await fetch(url, {
                method: "PUT",
                headers: { "Content-Type": mimetype },
                body: file
            });

            const updatedDocs = updateFileInDocument(documentos, tipo, documento, s3Key, filename, user);
            await updateDocument(tabla, empresa, documentos.id, { [tipo]: updatedDocs[tipo] });

            refetch();
            onClose();
            toast.success("Documento subido correctamente");
        } catch (error) {
            console.error(error);
            toast.error("Error al subir archivos");
        } finally {
            setLoading(false);
        }
    }; 

    const initialValues = { doc:"" };

    const validate = (values) => {
        const errors = {};
        if (!file) {
            errors.doc = "Campo requerido";
        }
        return errors;
    };

    return(
        <Formik onSubmit={onUploadSubmit} initialValues={initialValues} validate={validate} >
            {({ errors, handleChange, values }) => (
                <Form className="p-4 flex flex-col items-center space-y-6">
                    <div className="w-full flex flex-col md:flex-row md:space-x-4">
                        <div className="flex flex-col w-full">
                            <label className="text-sm font-bold mb-1">{tipo}.{documento.typeFile}</label>
                            <input
                                id="doc"
                                type="file"
                                accept={`.${documento.typeFile}`}
                                onChange={(event) => setFile(event.currentTarget.files[0])}
                                className="w-full p-2 border-2 border-black rounded-xl"
                            />
                            {errors && <p className="text-[#e73842] text-sm mb-2">{errors.doc}</p>}
                        </div>
                    </div>
                    <Button type="submit" text={loading ? <PropagateLoader color="red" /> :"Enviar"} bgColor="blue" disabled={loading}/>
                </Form>
            )}
        </Formik>
    );
};

export default ModalUpdateFile;